import { FC, ReactNode, useEffect, useRef } from 'react';
import { twMerge } from 'tailwind-merge';

import joakimImg from 'static/assets/img/joakim.png';
import triangleImg from 'static/assets/img/triangle.png';
import { createPlaySoundFunction } from '../helpers';
import popSound from 'static/assets/audio/msgPop.mp3';

type Props = {
  className?: string;
  bottomRightElement?: ReactNode;
  playSpawnSound?: boolean;
  children?: ReactNode;
};

export const MessageBox: FC<Props> = ({ className = '', bottomRightElement, playSpawnSound = false, children }) => {
  const playMessageSpawnSound = useRef(createPlaySoundFunction(popSound, 1)).current;

  useEffect(() => {
    if (playSpawnSound) playMessageSpawnSound();
  }, []);

  return (
    <div className={twMerge('mb-2 flex flex-row gap-4 button-wobble', className)}>
      <img src={joakimImg} alt="joakim vært" className="w-12 h-12 mt-4 object-cover border-2 border-white rounded-full" />
      <div className="relative w-full px-4 pt-4 pb-3 bg-white rounded-xl mt-3">
        <img src={triangleImg} alt="misc" className="absolute left-[-10px] top-5" />
        {children}
        <div className="absolute right-3 bottom-2 text-black">{bottomRightElement}</div>
      </div>
    </div>
  );
};
